import {
  theftProtectionRatingTypesService,
  type TheftProtectionRatingType,
} from '@/services/theft-protection-rating-types';
import { useQuery } from '@tanstack/react-query';

type UseTheftProtectionRatingTypesParams = {
  enabled?: boolean;
};

export function useTheftProtectionRatingTypes({
  enabled = true,
}: UseTheftProtectionRatingTypesParams = {}) {
  return useQuery<TheftProtectionRatingType[], Error>({
    queryKey: ['theft-protection-rating-types'],
    queryFn: async () => {
      const response =
        await theftProtectionRatingTypesService.getTheftProtectionRatingTypes();

      if (!response.success || !response.data) {
        throw new Error(
          response.error ||
            'Erro ao carregar sistemas de proteção contra roubo'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
